import { CountUp } from 'countup.js';

import '../sass/text-media-and-stats-carousel.scss';

(() => {
    const swiperScript = document.querySelector('#ofg-schools-swiper-js');
    const $blocks = document.querySelectorAll('.block.text-media-and-stats-carousel');

    if (!$blocks.length) return;

    const animateSlideStats = ($slide) => {
        if (!$slide || $slide.dataset.timelineStatsAnimated === 'true') return;

        const $carousel = $slide.closest('.text-media-and-stats-carousel__carousel');

        if (!$carousel?.classList.contains('is-on-screen')) return;

        const $numbers = $slide.querySelectorAll('.text-media-and-stats-carousel__stat-number');

        if (!$numbers.length) return;

        $slide.dataset.timelineStatsAnimated = 'true';

        $numbers.forEach($number => {
            const counter = new CountUp($number);

            if (!counter.error) {
                counter.start();
            }
        });
    };

    const animateActiveSlideStats = ($carousel) => {
        const $activeSlide = $carousel.querySelector('.swiper-slide-active');

        animateSlideStats($activeSlide);
    };

    $blocks.forEach($block => {
        const $carousel = $block.querySelector('.text-media-and-stats-carousel__carousel');
        const $navigationPrev = $block.querySelector('.text-media-and-stats-carousel__navigation-prev');
        const $navigationNext = $block.querySelector('.text-media-and-stats-carousel__navigation-next');

        const initCarousel = () => {
            if (!$carousel) return;

            new Swiper($carousel, {
                slidesPerView: 1,
                spaceBetween: 0,
                speed: 600,
                watchOverflow: true,
                keyboard: {
                    enabled: true,
                    onlyInViewport: true,
                },
                navigation: {
                    prevEl: $navigationPrev,
                    nextEl: $navigationNext,
                },
                on: {
                    init() {
                        animateActiveSlideStats($carousel);
                    },
                    slideChange() {
                        animateActiveSlideStats($carousel);
                    },
                },
            });

            $carousel.addEventListener('onScreen', () => {
                animateActiveSlideStats($carousel);
            });

            if ($carousel.classList.contains('is-on-screen')) {
                animateActiveSlideStats($carousel);
            }
        };

        if (typeof Swiper !== 'undefined') {
            initCarousel();
        } else if (swiperScript) {
            swiperScript.addEventListener('load', () => {
                initCarousel();
            });
        } else {
            window.addEventListener('load', () => {
                const loadedSwiperScript = document.querySelector('#ofg-schools-swiper-js');

                if (!loadedSwiperScript) return;

                initCarousel();
            });
        }
    });
})();
